import { graphql } from "react-relay";

export const ValidateCronExpressionMutation = graphql`
  mutation ValidateCronExpressionMutation($input: ValidateCronExpressionInput!) {
    validateCronExpression(input: $input) {
      isValid
      nextFireTime
      errorMessage
    }
  }
`;